import { selectTemplateId } from 'modules/campaignAnalytics/selectors';
import { LocalesQueryContextProvider } from 'modules/campaigns/lib/contexts/LocalesQueryContext/LocalesQueryContextProvider';
import { useSelector } from 'react-redux';
import { LayoutTemplate } from '../LayoutTemplate';
import { CustomRepliesCard, QuickRepliesCard } from './cards';

export const Replies = () => {
  const templateId = useSelector(selectTemplateId);
  return (
    <LayoutTemplate canShowFPOBanner={false} pageName="Replies">
      <LocalesQueryContextProvider templateId={templateId}>
        <QuickRepliesCard />
        <CustomRepliesCard />
      </LocalesQueryContextProvider>
    </LayoutTemplate>
  );
};
